import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { Box, Typography, Button, Paper } from '@weave-mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.handleReset = () => {
            this.setState({
                hasError: false,
                error: null,
                errorInfo: null,
            });
        };
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error,
            errorInfo: null,
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Error caught by boundary:', error, errorInfo);
        this.setState({
            error,
            errorInfo,
        });
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (_jsx(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh',
                    bgcolor: 'background.default',
                    p: 3,
                }, children: _jsxs(Paper, { elevation: 3, sx: {
                        p: 4,
                        maxWidth: 600,
                        textAlign: 'center',
                    }, children: [_jsx(ErrorOutlineIcon, { sx: {
                                fontSize: 64,
                                color: 'error.main',
                                mb: 2,
                            } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: "Something went wrong" }), _jsx(Typography, { variant: "body1", color: "text.secondary", paragraph: true, children: this.state.error?.message || 'An unexpected error occurred' }), process.env.NODE_ENV === 'development' && this.state.errorInfo && (_jsx(Paper, { variant: "outlined", sx: {
                                p: 2,
                                mt: 2,
                                textAlign: 'left',
                                bgcolor: 'grey.100',
                                maxHeight: 300,
                                overflow: 'auto',
                            }, children: _jsx(Typography, { variant: "caption", component: "pre", sx: { whiteSpace: 'pre-wrap' }, children: this.state.error?.stack }) })), _jsxs(Box, { sx: { mt: 3, display: 'flex', gap: 2, justifyContent: 'center' }, children: [_jsx(Button, { variant: "contained", onClick: this.handleReset, children: "Try Again" }), _jsx(Button, { variant: "outlined", onClick: () => (window.location.href = '/'), children: "Go to Home" })] })] }) }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
